import React, { Component } from 'react';

import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';

import Staff from '../Components/Master/Staff/Staff';

class AddStaffContainerMain extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));
        
        
        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
        
    }
    
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">
               
                            <Staff
                                
                                history={this.props.history}
                                title="Staff"
                                code="staff"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />
                    

                   

                </div>
            </div>
        )
    }
}

export default withAuth(AddStaffContainerMain);



// WEBPACK FOOTER //
// ./src/Containers/AddStaffContainerMain.js